export default __webpack_public_path__ + "static/media/ComparisonActive.94133c72.svg";